(function(){
  var ROOTS={
    'clore-jug5-product':{
      images:[
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/CopyofShopifyProductImages_1.png?v=1783906123',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/SingleJug-Copy.jpg?v=1783045754',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947'
      ],
      giftImage:'https://ember-shield-source.lovable.app/__l5e/assets-v1/9dfead45-334b-4a4f-b6d6-772c40e53ebe/hand-sprayer.jpg',
      includes:['1 x 5 gallon jug of ready-to-use Clore','1 x hand pump sprayer','Two year sprayer guarantee if purchased Clore in two years','Application guide and coverage chart','Free shipping']
    },
    'clore-kit10-product':{
      images:[
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/10.jpg?v=1786663592',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/1_jug_in_front_of_door.png?v=1787510610',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
      ],
      giftImage:'https://ember-shield-source.lovable.app/__l5e/assets-v1/429fea26-2761-4f57-93db-54b970556f94/member-gift-sprayer.jpg',
      includes:['1 x 5 gallon jug of Clore concentrate (makes 10 gallons)','1 x lithium ion battery backpack sprayer + nozzles, fittings, and charger','Two year sprayer guarantee if purchased Clore in two years','Application guide and coverage chart','Free shipping']
    },
    'clore-kit20-product':{
      images:[
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/11.jpg?v=1786663592',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/2_jugs_in_front_of_door.png?v=1787510610',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
      ],
      giftImage:'https://ember-shield-source.lovable.app/__l5e/assets-v1/429fea26-2761-4f57-93db-54b970556f94/member-gift-sprayer.jpg',
      includes:['2 x 5 gallon jugs of Clore concentrate (makes 20 gallons)','1 x lithium ion battery backpack sprayer + nozzles, fittings, and charger','Two year sprayer guarantee if purchased Clore in two years','Application guide and coverage chart','Free shipping']
    },
    'clore-kit30-product':{
      images:[
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/12.jpg?v=1786663592',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Live_Action_Spraying_86017363-5135-468f-9a8b-6505b63595d3.jpg?v=1786740181',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/3_jugs_in_front_of_door.png?v=1787510610',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Product_Images_Shopify_811.jpg?v=1786663806',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/ChatGPT_Image_Aug_23_2026_03_35_07_PM.png?v=1787510127',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/Clore_test_logoBR_1.png?v=1778699947',
        'https://cdn.shopify.com/s/files/1/0818/6671/9467/files/EE2E232D-0D16-4C4F-9B54-6FEBD42B5DA2_1_105_c_6f6f73cb-bfb7-43ab-939b-bc137e9e0d77.jpg?v=1778777165'
      ],
      giftImage:'https://ember-shield-source.lovable.app/__l5e/assets-v1/429fea26-2761-4f57-93db-54b970556f94/member-gift-sprayer.jpg',
      includes:['3 x 5 gallon jugs of Clore concentrate (makes 30 gallons)','1 x lithium ion battery backpack sprayer + nozzles, fittings, and charger','Two year sprayer guarantee if purchased Clore in two years','Application guide and coverage chart','Free shipping']
    }
  };

  function svg(path){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+path+'</svg>'}
  var icons={
    shield:svg('<path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3v8Z"></path><path d="m9 12 2 2 4-4"></path>'),
    leaf:svg('<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"></path><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"></path>'),
    beaker:svg('<path d="M4.5 3h15"></path><path d="M6 3v5.5l-3.2 8.8A3 3 0 0 0 5.6 21h12.8a3 3 0 0 0 2.8-3.7L18 8.5V3"></path><path d="M8 14h8"></path>'),
    calendar:svg('<path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path>'),
    box:svg('<path d="m21 8-9-5-9 5 9 5 9-5Z"></path><path d="M3 8v8l9 5 9-5V8"></path><path d="M12 13v8"></path>'),
    sparkles:svg('<path d="m12 3-1.9 5.8L4 10.5l6.1 1.7L12 18l1.9-5.8 6.1-1.7-6.1-1.7L12 3Z"></path><path d="M5 3v4"></path><path d="M3 5h4"></path>'),
    clock:svg('<circle cx="12" cy="12" r="10"></circle><path d="M12 6v6l4 2"></path>'),
    book:svg('<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M4 4.5A2.5 2.5 0 0 1 6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15Z"></path>'),
    truck:svg('<path d="M10 17h4V5H2v12h3"></path><path d="M20 17h2v-6h-8v6h1"></path><circle cx="7.5" cy="17.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>')
  };

  function card(title,icon,body){
    return '<div class="clore-shared-card"><div class="clore-shared-card__inner"><div class="text-center"><span class="clore-shared-icon mx-auto mb-3 h-12 w-12">'+icon+'</span><h3 class="font-heading font-extrabold text-deep-forest text-lg">'+title+'</h3></div>'+body+'</div></div>';
  }

  function repairRecommendationLinks(root){
    root.querySelectorAll('a[href*="/pages/defend"][href*="openKitQuiz=1"]').forEach(function(link){
      try{
        var url=new URL(link.getAttribute('href'),window.location.origin);
        url.searchParams.delete('restartQuiz');
        link.setAttribute('href',url.pathname+url.search+url.hash);
      }catch(e){}
    });
  }

  function repairHomeLinks(root){
    root.querySelectorAll('nav[aria-label="Breadcrumb"] a').forEach(function(link){
      if(link.textContent.trim()==='Home')link.setAttribute('href','/pages/defend?viewDefendPage=1');
    });
  }

  function repairGallery(root,info){
    var gallery=root.querySelector('[data-ember-gallery]');
    if(!gallery||!info.images.length)return;
    var images=info.images.slice(), main=gallery.querySelector('[data-ember-gallery-main]'), alt=gallery.getAttribute('data-gallery-alt')||'Product', idx=0;
    var oldPrev=gallery.querySelector('[data-ember-gallery-prev]'), oldNext=gallery.querySelector('[data-ember-gallery-next]');
    var prev=oldPrev?oldPrev.cloneNode(true):null, next=oldNext?oldNext.cloneNode(true):null;
    if(oldPrev)oldPrev.replaceWith(prev);
    if(oldNext)oldNext.replaceWith(next);
    gallery.setAttribute('data-gallery-images',JSON.stringify(images));
    var oldDot=gallery.querySelector('[data-ember-gallery-dot]'), dotWrap=oldDot&&oldDot.parentElement;
    if(dotWrap){
      dotWrap.innerHTML=images.map(function(_,i){return '<button type="button" aria-label="Go to image '+(i+1)+'" data-clore-gallery-dot="'+i+'" class="h-1.5 rounded-full transition-all '+(i===0?'w-5 bg-accent':'w-1.5 bg-slate-charcoal/30')+'"></button>'}).join('');
    }
    function show(nextIndex){
      idx=(nextIndex+images.length)%images.length;
      if(main){main.src=images[idx];main.alt=alt+' image '+(idx+1);}
      if(dotWrap)dotWrap.querySelectorAll('[data-clore-gallery-dot]').forEach(function(dot,i){dot.className='h-1.5 rounded-full transition-all '+(i===idx?'w-5 bg-accent':'w-1.5 bg-slate-charcoal/30');});
    }
    if(prev)prev.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();show(idx-1);});
    if(next)next.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();show(idx+1);});
    if(dotWrap)dotWrap.querySelectorAll('[data-clore-gallery-dot]').forEach(function(dot){dot.addEventListener('click',function(ev){ev.preventDefault();ev.stopPropagation();show(Number(dot.getAttribute('data-clore-gallery-dot')||0));});});
    images.forEach(function(src){var preload=new Image();preload.src=src;});
    show(0);
  }

  function matchWhySection(root){
    var section=root.querySelector('#why-clore');
    if(!section)return;
    section.className='container mx-auto px-4 max-w-5xl py-8 sm:py-10';
    section.innerHTML=card('Why your plan works',icons.shield,'<ul class="mt-4 space-y-3"><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.leaf+'</span><span class="leading-relaxed pt-1.5"><span class="block">Same EPA toxicity level as lemonade.</span><span class="block mt-0.5">Safe for animals, plants, and people</span></span></li><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.beaker+'</span><span class="leading-relaxed pt-1.5">Mostly made of salts and a little fertilizer, all ingredients found around the house</span></li><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.calendar+'</span><span class="leading-relaxed pt-1.5">Lasts 8 months of UV or 3 inches of rain</span></li><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.box+'</span><span class="leading-relaxed pt-1.5">Stores sealed and under cover at least 4 years</span></li><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.sparkles+'</span><span class="leading-relaxed pt-1.5">Dries clear</span></li><li class="flex items-start gap-3 text-sm text-slate-charcoal"><span class="clore-shared-icon h-8 w-8 shrink-0">'+icons.clock+'</span><span class="leading-relaxed pt-1.5">Applied in under 60 minutes</span></li></ul>');
  }

  function matchIncludesSection(root,info){
    var section=root.querySelector('#the-kit'), config=window.CloreProductEnhancements||{};
    if(!section)return;
    var items=info.includes.map(function(item,i){
      var visual='';
      if(i===0)visual='<img src="'+config.jugPackImage+'" alt="'+item+'" class="clore-shared-image">';
      else if(i===1)visual='<img src="'+info.giftImage+'" alt="'+item+'" class="clore-shared-image">';
      else{
        var icon=/sprayer guarantee/i.test(item)?icons.shield:(/Application guide/i.test(item)?icons.book:icons.truck);
        visual='<span class="clore-shared-icon h-12 w-12 sm:h-14 sm:w-14 shrink-0">'+icon+'</span>';
      }
      var manual=i===1&&/sprayer/i.test(item)&&!/hand pump/i.test(item)?' <a href="'+config.sprayerManualUrl+'" target="_blank" rel="noopener noreferrer" class="text-accent underline underline-offset-2 hover:text-accent/80">Sprayer Manual PDF</a>':'';
      return '<li class="flex items-center gap-3 text-sm text-slate-charcoal">'+visual+'<span>'+item+manual+'</span></li>';
    }).join('');
    section.className='container mx-auto px-4 max-w-5xl pb-8 sm:pb-10';
    section.innerHTML=card('Includes everything you need',icons.box,'<ul class="mt-4 space-y-3">'+items+'</ul>');
  }

  function enhanceSubscription(root){
    var deliveryTitle=root.querySelector('.clore-product-delivery-title');
    if(!deliveryTitle)return;
    var subscriptionCard=deliveryTitle.closest('.rounded-2xl');
    if(!subscriptionCard)return;
    subscriptionCard.classList.add('clore-product-subscription-card');

    var header=subscriptionCard.querySelector(':scope > .w-full');
    if(header){
      Array.from(header.querySelectorAll('span')).filter(function(el){return !el.children.length;}).forEach(function(el){
        var text=el.textContent.trim();
        if(text==='Subscribe & Save 10%')el.classList.add('clore-product-subscribe-title');
        else if(text==='Free shipping · Cancel anytime')el.classList.add('clore-product-subscribe-meta');
        else if(/^\$/.test(text)&&el.classList.contains('line-through'))el.classList.add('clore-product-subscribe-old-price');
        else if(/^\$/.test(text))el.classList.add('clore-product-subscribe-price');
      });
    }

    var oldToggle=root.querySelector('[data-clore-product-delivery-toggle]');
    var options=root.querySelector('[data-clore-product-delivery-options]');
    if(!oldToggle||!options)return;
    var toggle=oldToggle.cloneNode(true);
    toggle.removeAttribute('data-clore-product-delivery-toggle');
    toggle.setAttribute('data-clore-enhanced-delivery-toggle','true');
    toggle.classList.add('clore-product-delivery-toggle');
    oldToggle.replaceWith(toggle);
    var deliveryBody=root.querySelector('.clore-product-delivery-body');
    var deliveryInput=root.querySelector('[data-clore-product-delivery-input]');
    var sellingPlanInput=root.querySelector('[data-clore-product-selling-plan-input]');
    var mode=sellingPlanInput&&sellingPlanInput.value==='11642863851'?'date':'april';

    function renderOptions(){
      options.innerHTML=['april','date'].map(function(optionMode){
        var active=optionMode===mode;
        var label=optionMode==='april'?'Ships first week of April each year':'Ships on this date each year';
        return '<button type="button" data-clore-enhanced-delivery="'+optionMode+'" class="w-full flex items-center gap-2 rounded-lg border px-3 py-1.5 text-left transition-colors '+(active?'border-accent bg-accent/10':'border-silver-sage/50 bg-background hover:border-accent/50')+'"><span class="h-3.5 w-3.5 shrink-0 rounded-full border flex items-center justify-center '+(active?'border-accent':'border-slate-charcoal/40')+'">'+(active?'<span class="h-1.5 w-1.5 rounded-full bg-accent"></span>':'')+'</span><span class="clore-product-delivery-option font-heading font-bold text-slate-charcoal leading-tight">'+label+'</span></button>';
      }).join('');
      options.querySelectorAll('[data-clore-enhanced-delivery]').forEach(function(button){
        button.addEventListener('click',function(){
          mode=button.getAttribute('data-clore-enhanced-delivery')||'april';
          deliveryTitle.textContent='Annual delivery: '+(mode==='date'?'This date each year':'Early April, early fire season');
          if(deliveryBody)deliveryBody.innerHTML='First order ships immediately<br>Next shipment: '+(mode==='date'?'this date next year':'April 2027');
          if(deliveryInput)deliveryInput.value=mode==='date'?'Ships on this date each year':'Ships first week of April each year';
          if(sellingPlanInput)sellingPlanInput.value=mode==='date'?'11642863851':'11642896619';
          renderOptions();
          options.classList.add('hidden');
        });
      });
    }
    renderOptions();
    toggle.addEventListener('click',function(){options.classList.toggle('hidden');if(!options.classList.contains('hidden'))renderOptions();});

    var giftTitle=root.querySelector('.clore-product-gift-title');
    var giftBlock=giftTitle&&giftTitle.closest('.flex.items-start.gap-3');
    if(giftBlock){
      giftBlock.classList.add('clore-product-gift-block');
      var primaryForm=giftBlock.nextElementSibling;
      if(primaryForm&&primaryForm.matches('form[data-clore-ember-cart-form]'))primaryForm.classList.add('clore-product-primary-add-form');
    }
  }

  function init(){
    var root=null,info=null;
    Object.keys(ROOTS).some(function(id){var candidate=document.getElementById(id);if(candidate){root=candidate;info=ROOTS[id];return true;}return false;});
    if(!root||root.dataset.cloreEnhancementsBound==='true')return;
    root.dataset.cloreEnhancementsBound='true';
    repairRecommendationLinks(root);
    repairHomeLinks(root);
    repairGallery(root,info);
    matchWhySection(root);
    matchIncludesSection(root,info);
    enhanceSubscription(root);
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
